import _ from 'lodash';
import {
    SECTION_TYPE_CUSTOMFIELD,
} from '../constants';
import CustomFieldsModal from '../components/customFieldsModal';

export default {
    components: {
        CustomFieldsModal,
    },
    computed: {
        customFieldSuggestInfo() {
            return _.find(this.suggestion, { section: SECTION_TYPE_CUSTOMFIELD });
        },

        isCustomField() {
            return this.customFieldSuggestInfo && !_.isEmpty(this.customFieldSuggestInfo);
        },

        customFieldValue() {
            const value = _.get(this.customFieldSuggestInfo, 'fieldValue', []);
            if (this.customFieldType === 'LAYER') {
                this.formatLayerFieldParentName(value, []);
            }
            return value;
        },

        customFieldValueLodading() {
            return _.get(this.customFieldSuggestInfo, 'loading', false);
        },

        customFieldSuggestTitle() {
            return _.get(this.customFieldSuggestInfo, 'title', '');
        },

        customFieldType() {
            return _.get(this.customFieldSuggestInfo, 'fieldType', '');
        },

        customFieldStem() {
            return _.get(this.customFieldSuggestInfo, 'keyword', '');
        },
    },

    methods: {
        onSelectCustomField(value) {
            const option = {
                section: SECTION_TYPE_CUSTOMFIELD,
                data: {
                    value,
                },
            };
            this.$emit('select-option', option);
        },

        formatLayerFieldParentName(fields, nameList = []) {
            _.forEach(fields, (item) => {
                // eslint-disable-next-line no-param-reassign
                item.parent_name_list = nameList;
                if (item.children && item.children.length) {
                    const newNameList = _.concat(nameList, [item.name]);
                    this.formatLayerFieldParentName(item.children, newNameList);
                }
            });
        },
    },

};
